// Keep in sync w/ apps/api/src/services/task/image-resize/image-resize.ts (RESIZE_WIDTHS)
export const RESIZE_WIDTHS = [50, 300, 500, 700, 900, 1200]

// 50 is an avatar-sized thumbnail; it looks pixelated even in a small print slot.
const PRINT_WIDTHS = RESIZE_WIDTHS.filter((width) => width >= 300)

/**
 * The resize variant to print an S3 image from: the smallest one at least as wide as the slot it
 * fills. A PDF prints photo thumbnails ~154px wide, but `ResponsiveImage`'s viewport-based `sizes`
 * picked the 900px copy for each one, so a 161-photo estimate became a 71 MB PDF that Browserless
 * could not return (#25493).
 *
 * Returns undefined when the slot width is unknown, so the caller keeps its normal source.
 */
export function getPrintImageWidth(slotWidth?: number | null): number | undefined {
  if (!slotWidth || slotWidth <= 0) {
    return undefined
  }
  return PRINT_WIDTHS.find((width) => width >= slotWidth) ?? PRINT_WIDTHS.at(-1)
}
